import type { RouteRecordRaw } from 'vue-router';

// 路由表：禁止任何浏览器副作用 import（无 css / 无进度条 / 无 window 逻辑）。
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('../views/home/index.vue'),
  },
  {
    path: '/exams/:id',
    component: () => import('../views/exam/detail.vue'),
    props: true,
  },
  {
    path: '/user',
    component: () => import('../views/user/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/user/exam/:id',
    component: () => import('../views/user/exam-detail.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/notice',
    component: () => import('../views/agreement/notice.vue'),
  },
  {
    path: '/privacy',
    component: () => import('../views/agreement/privacy.vue'),
  },
  {
    path: '/callback',
    component: () => import('../views/auth/callback.vue'),
    props: route => ({
      code: route.query.code,
      from: route.query.from,
    }),
  },

  // 注意：404 路由，业务路由都要放在这前面
  {
    name: 'notFound',
    path: '/404',
    component: () => import('../views/common/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/common/404.vue'),
  },
];
